<template>
  <transition name="fade">
    <div
      v-show="toastShow"
      class="toast"
      :class="{ 'string-toast': !icon, normal: isNormal }"
    >
      <img v-if="type === 'warn'" class="icon" src="../assets/icon-warn.svg" />
      <img
        v-else-if="type === 'network'"
        class="icon"
        src="../assets/network-err.svg"
      />
      <img v-else v-show="icon" class="icon" :src="icon" alt />
      <p v-show="toastString">{{ toastString }}</p>
    </div>
  </transition>
</template>

<script lang="ts">
// 零时的 toast，需要兼容字符串样式，验证码样式，以及普通样式
import { Vue, Component, Prop } from 'vue-property-decorator';
import network from '../assets/netwrok-err.svg';
import warn from '../assets/icon-warn.svg';
export interface IToast {
  icon?: string;
  value?: string;
  type?: string;
}
@Component({})
export default class Toast extends Vue {
  toastShow = false;
  toastString = '';
  icon = '';
  type = '';
  get isNormal() {
    return this.type === 'warn' || this.type === 'network';
  }
  toast(conf: string | IToast) {
    this.unset();
    this.setup(conf);
    this.toastShow = true;
    setTimeout(() => {
      this.toastShow = false;
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    }, 1500);
  }
  setup(conf: string | IToast) {
    if (typeof conf === 'string') {
      this.toastString = conf;
      return;
    }
    conf.type && (this.type = conf.type);
    this.icon = conf.icon || '';
    this.toastString = conf.value || '';
  }
  unset() {
    this.toastString = '';
    this.icon = '';
    this.type = '';
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.6s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 380px;
  padding: 56px 0;
  // padding: 38px 60px;
  background: rgba($color: #000000, $alpha: 0.7);
  border-radius: 10px;
  transform: translate(-50%, -50%);

  .icon {
    width: 64px;
    height: 64px;
    margin-bottom: 41px;
  }
  p {
    color: #fff;
    font-weight: 500;
    font-size: 28px;
  }
}
.string-toast {
  width: auto;
  padding: 15px 30px;
}
.normal {
  width: 180px;
  height: 180px;
  .icon {
    width: 72px;
    height: 72px;
    margin-bottom: 13px;
  }
}
</style>
